var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.33203H4.00008C3.64646 1.33203 3.30732 1.47251 3.05727 1.72256C2.80722 1.9726 2.66675 2.31174 2.66675 2.66536V13.332C2.66675 13.6857 2.80722 14.0248 3.05727 14.2748C3.30732 14.5249 3.64646 14.6654 4.00008 14.6654H12.0001C12.3537 14.6654 12.6928 14.5249 12.9429 14.2748C13.1929 14.0248 13.3334 13.6857 13.3334 13.332V4.66536L10.0001 1.33203Z",
    stroke: "#FAA11C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 1.33203V3.9987C9.33325 4.35232 9.47373 4.69146 9.72378 4.94151C9.97383 5.19156 10.313 5.33203 10.6666 5.33203H13.3333",
    stroke: "#FAA11C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 6H5.33325",
    stroke: "#FAA11C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 8.66797H5.33325",
    stroke: "#FAA11C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 11.332H5.33325",
    stroke: "#FAA11C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.eb2ec7c9916d804eda34da453398b610.svg";
export { ForwardRef as ReactComponent };